module.exports = __webpack_public_path__ + "img/kangaroo-time-logo.b9de9c87.png";